import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  API,
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

class Settings extends PureComponent {
  onChangeAdProgram = () => {
    const {
      adProgramEnabled,
      onUpdate,
    } = this.props;

    onUpdate({
      adProgramEnabled: !adProgramEnabled,
    });
  };

  onDropdownChange = (e) => {
    const {
      onUpdate,
    } = this.props;

    const {
      name,
      value,
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  onChangeAdNetwork = () => {
    const {
      adNetworkEnabled,
      onUpdate,
    } = this.props;

    onUpdate({
      adNetworkEnabled: !adNetworkEnabled,
    });
  };

  titleCase = (string) => {
    return string
      ? string.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
      : string;
  };

  render() {
    const {
      user,
      adNetworkOwner,
      adDeliverySystem,
      contentNetworkOwner,
      contentDeliverySystem,
      adProgramEnabled,
      adNetworkEnabled,
      companyAdProgramEnabled,
      companyAdNetworkEnabled,
      disableInput,
      canEdit,
    } = this.props;

    const canAdminEdit = user.sysAdmin && !disableInput;
    const canEnableAdPrograms = user.can('location-ad-program.modify');

    return (
      <div className="Settings location">
        <Grid spacing={2} container>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Field
              type="toggle"
              label="Ad Network"
              toggleProps={{
                label: 'Enable Ad Network',
                helpText: !companyAdNetworkEnabled
                  ? 'Company ad network is disabled'
                  : null,
              }}
              value={adNetworkEnabled
                ? 'on'
                : 'off'}
              tabIndex={50}
              disabled={!canAdminEdit || !companyAdNetworkEnabled || adProgramEnabled}
              onChange={this.onChangeAdNetwork}
            />
          </Grid>

          {canEnableAdPrograms && (
            <Grid size={{ xs: 12, lg: 6 }}>
              <Field
                type="toggle"
                label="Enable Ad Program"
                toggleProps={{
                  label: 'Enable Ad Program',
                  helpText: !companyAdProgramEnabled
                    ? 'Company ad program is disabled'
                    : null,
                }}
                value={adProgramEnabled
                  ? 'on'
                  : 'off'}
                tabIndex={51}
                disabled={!canAdminEdit || !companyAdProgramEnabled || !adNetworkEnabled}
                onChange={this.onChangeAdProgram}
              />
            </Grid>
          )}

          <Grid size={{ xs: 12, lg: 6 }}>
            <Field
              type="dropdown"
              label="Content Network Owner"
              name="contentNetworkOwner"
              value={this.titleCase(contentNetworkOwner)}
              tabIndex={52}
              dropdownProps={{
                type: 'network owner',
                attr: 'value',
                fetch: API.LookupList.contentNetworkOwners.search,
              }}
              disabled={!canEdit}
              required
              onChange={this.onDropdownChange}
            />
          </Grid>

          <Grid size={{ xs: 12, lg: 6 }}>
            <Field
              type="dropdown"
              label="Content Delivery System"
              name="contentDeliverySystem"
              value={this.titleCase(contentDeliverySystem)}
              tabIndex={53}
              dropdownProps={{
                type: 'delivery system',
                attr: 'value',
                fetch: API.LookupList.contentDeliverySystems.search,
              }}
              disabled={!canEdit}
              required
              onChange={this.onDropdownChange}
            />
          </Grid>

          {adNetworkEnabled && (
            <>
              <Grid size={{ xs: 12, lg: 6 }}>
                <Field
                  type="dropdown"
                  label="Ad Delivery System"
                  name="adDeliverySystem"
                  value={this.titleCase(adDeliverySystem)}
                  tabIndex={54}
                  dropdownProps={{
                    type: 'delivery system',
                    attr: 'value',
                    fetch: API.LookupList.adDeliverySystems.search,
                  }}
                  disabled={!canEdit}
                  required={adNetworkEnabled}
                  onChange={this.onDropdownChange}
                />
              </Grid>

              <Grid size={{ xs: 12, lg: 6 }}>
                <Field
                  type="dropdown"
                  label="Ad Network Owner"
                  name="adNetworkOwner"
                  value={this.titleCase(adNetworkOwner)}
                  tabIndex={55}
                  dropdownProps={{
                    type: 'network owner',
                    attr: 'value',
                    fetch: API.LookupList.adNetworkOwners.search,
                  }}
                  disabled={!canEdit}
                  required={adNetworkEnabled}
                  onChange={this.onDropdownChange}
                />
              </Grid>
            </>
          )}
        </Grid>
      </div>
    );
  }
}

Settings.propTypes = {
  adProgramEnabled: PropTypes.bool,
  companyAdProgramEnabled: PropTypes.bool,
  adNetworkEnabled: PropTypes.bool,
  companyAdNetworkEnabled: PropTypes.bool,
  disableInput: PropTypes.bool,
  onUpdate: PropTypes.func,
};

Settings.defaultProps = {
  adProgramEnabled: false,
  companyAdProgramEnabled: false,
  adNetworkEnabled: false,
  companyAdNetworkEnabled: false,
  disableInput: false,
  onUpdate: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Settings);
